import { CheckoutPerson } from '../../models/checkout/checkout-person.interface';

export const mockCheckoutPerson: CheckoutPerson = {
  firstName: 'Jon',
  surname: 'Doe',
  phone: [
    {
      type: 'L',
      usage: 'PER',
      value: '6019521325',
      preferred: true,
    },
  ],
  email: [
    {
      usage: 'PER',
      value: 'test@example.us',
      preferred: true,
    },
  ],
  address: [
    {
      addressCategoryCode: 'BIL',
      addressLine1: '180 Garth Rd Apt TE',
      addressLine2: 'Address line 2',
      addressLine3: 'Scarsdale',
      postalCode: '10583-3839',
      region: 'NY',
      countryCode: 'USA',
      addressOverride: false,
    },
  ],
};
